import React, { useEffect } from "react";
import { Route, Switch, Redirect, withRouter } from "react-router-dom";
import { connect, useSelector, useDispatch } from "react-redux";
import AppLayout from "layouts/app-layout";
import AuthLayout from "layouts/auth-layout";
import AppLocale from "lang";
import { IntlProvider } from "react-intl";
import { ConfigProvider } from "antd";
import { APP_PREFIX_PATH, AUTH_PREFIX_PATH } from "configs/AppConfig";
import useBodyClass from "hooks/useBodyClass";
import axios from "axios";

import { UserCheckAuthService } from "redux/actions/User";
import { env } from "../configs/EnvironmentConfig";
import { AUTH_TOKEN } from "../redux/constants/Auth";

export const Views = (props) => {
  const { locale, location, direction } = props;
  const currentAppLocale = AppLocale[locale];
  useBodyClass(`dir-${direction}`);

  const myCustomErrorFunction = () => {
    console.log("er");
  };

  const API_BASE_URL = env.API_ENDPOINT_URL;
  const dispatch = useDispatch();

  useEffect(() => {
    let localToken = localStorage.getItem(AUTH_TOKEN);
    axios
      .get(`${API_BASE_URL}/UserCheckAuthService`, {
        headers: {
          Authorization: "Bearer " + localToken,
        },
      })
      .then(function (response) {
        dispatch(UserCheckAuthService(response.data));
      })
      .catch(function (error) {
        console.log(error);
      });
  }, []);

  return (
    <IntlProvider
      locale={currentAppLocale.locale}
      // locale="en"
      messages={currentAppLocale.messages}
      onError={(err) => {
        if (err.code === "MISSING_TRANSLATION") {
          console.warn("Missing translation", err.message);
          return;
        }
        throw err;
      }}
      // onError={myCustomErrorFunction}
    >
      <ConfigProvider locale={currentAppLocale.antd} direction={direction}>
        <Switch>
          <Route exact path="/">
            <Redirect to={AUTH_PREFIX_PATH} />
          </Route>
          <Route path={AUTH_PREFIX_PATH}>
            <AuthLayout direction={direction} />
          </Route>
          <Route path={APP_PREFIX_PATH}>
            <AppLayout direction={direction} location={location} />
          </Route>
        </Switch>
      </ConfigProvider>
    </IntlProvider>
  );
};

const mapStateToProps = ({ theme, auth }) => {
  const { locale, direction } = theme;
  const { token } = auth;
  return { locale, token, direction };
};

export default withRouter(connect(mapStateToProps)(Views));
